import './vfigma.colors.scss';
import './vfigma.parcel.css';
import { declareComponents, declareDirectives } from '/vodalys/vvuejs'


import components from './component/**/*.vue'
declareComponents('components', components)

import directives from './directive/*.vue'
declareDirectives('directives', directives)